import TheFooter from './TheFooter'
import TheNavbar from './TheNavbar'

export {
  TheFooter,
  TheNavbar
}



// WEBPACK FOOTER //
// ./src/components/common/index.js